import { createAction } from "@reduxjs/toolkit";

export const fetchConfig = createAction("FETCH_CONFIG@configuration");

export const fetchConfigSuccess = createAction("FETCH_CONFIG_SUCCESS@configuration");

export const fetchConfigFailed = createAction("FETCH_CONFIG_FAILED@configuration");
